import { render, staticRenderFns } from "./ReportWrapper.vue?vue&type=template&id=33190c2c&"
import script from "./ReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./ReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports